import Reveal from './Reveal';

export default function PageHero({ eyebrow, title, description, subtitle, cover_image }) {
  const desc = description || subtitle;
  return (
    <section className="hero-grain relative overflow-hidden bg-cnib-navy pb-16 pt-32 md:pb-24 md:pt-44">
      {cover_image && (
        <img src={cover_image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      )}
      <div className="absolute inset-0 bg-gradient-to-br from-cnib-navy via-cnib-navy to-cnib-blue/40" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal y={20}>
          {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.3em] text-orange-500">{eyebrow}</p>}
          <h1 className="mt-4 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            {title}
          </h1>
          {desc && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">{desc}</p>}
        </Reveal>
      </div>
    </section>
  );
}
